// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"8":"7fd7a0b8b5927a70","405":"7fd7a0b8b5927a70","888":"bf6e2f393bb036ad","953":"7fd7a0b8b5927a70"}[chunkId] + ".css";
};